// src/pages/GraciasPage.js
import React from 'react';

function GraciasPage() {
  return (
    <div style={{ padding: '50px', textAlign: 'center' }}>
      <h2>¡Gracias por enviarnos su información!</h2>
      <p>Nos pondremos en contacto con usted muy pronto.</p>
    </div>
  );
}

export default GraciasPage;
